export class Annonceur {

    public mail: String;
    public login: String;

    constructor(){
    }

}
